export default __webpack_public_path__ + "static/media/gitea.b754e7cf.svg";